import { fromJS, List, Map, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { chartFactory } from '../../charts/chart.helper';
import { ITyped } from '../../shared/interfaces/typed.interface';
import { DashboardComponentTypesEnum } from '../reports.enum';
import { DashboardList } from './dashboard-list.model';
import { Link } from './link.model';
import { Summary } from './summary.model';
import { Text } from './text.model';

export const TAB_CONTENT_SCHEMA = Object.freeze({
  LABEL: '',
  VALUE: '',
  SELECTED: false,
  CONTENT: List<ITyped>([]),
});
const RECORD = generateSchema(TAB_CONTENT_SCHEMA);
const KEYS: any = generateKeys(TAB_CONTENT_SCHEMA);

export class TabContent extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CONTENT,
        value: props.get(KEYS.CONTENT)
          ? props
              .get(KEYS.CONTENT)
              .map((params) => this._tabContentFactory(params))
          : List<ITyped>([]),
      },
    ]);

    return selfModel as TabContent;
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get value(): string {
    return this.get(KEYS.VALUE);
  }

  get selected(): boolean {
    return this.get(KEYS.SELECTED);
  }

  get content(): List<ITyped> {
    return this.get(KEYS.CONTENT);
  }

  private _tabContentFactory(props: Map<string, any>): ITyped {
    const entryType: string = props.get('type');
    const componentType = entryType;

    switch (componentType) {
      case DashboardComponentTypesEnum.link:
        return new Link(props);
      case DashboardComponentTypesEnum.list:
        return new DashboardList(props);
      case DashboardComponentTypesEnum.summary:
        return new Summary(props);
      case DashboardComponentTypesEnum.text:
        return new Text(props);
    }

    try {
      return chartFactory(props);
    } catch (error) {
      throw new Error(`Unsupported tab content type: ${entryType}.`);
    }
  }
}
